import { animate, state, style, transition, trigger } from '@angular/animations';

export const mazChatAnimation = trigger('toggleMazChat', [
  state('expanded', style({ height: '100%' })),
  state('collapsed', style({ height: '156px' })),
  transition('expanded <=> collapsed', [animate('0.2s ease-out')]),
]);
